import { rem } from "polished";
import styled from "styled-components";

export const Wrapper = styled.div`
  border: ${rem(2)} solid #000;
  background-color: white;
  margin: 0 ${rem(12)} ${rem(24)} ${rem(12)};
  width: 100%;
  max-width: ${rem(384)};
  overflow: hidden;
`;

export const ContentWrapper = styled.div`
  padding: ${rem(24)};
  position: relative;
  background: #fff;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: ${rem(8)};
`;

export const Logo = styled.img`
  height: ${rem(32)};
  width: ${rem(32)};
  object-fit: cover;
  border-radius: 50%;
  margin-right: ${rem(8)};
`;

export const Heading = styled.h4`
  font-family: ${({ theme }) =>
    theme.fontImports[0]?.font?.name ?? theme.fonts[0].value};
  color: #000;
  font-weight: 600;
  font-size: ${rem(20)};
  line-height: ${rem(32)};
`;

export const Description = styled.p`
  font-family: ${({ theme }) =>
    theme.fontImports[0]?.font?.name ?? theme.fonts[0].value};
  color: #4a4a4a;
  font-weight: 400;
  font-size: ${rem(14)};
  line-height: ${rem(26)};
`;
